<div class="more-info-required">
  <mat-icon svgIcon="info"></mat-icon>
  <span class="copy">This category may require more information. Our team will reach out with any additional questions.</span>
</div>
